import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateCategoryForm from "../../forms/CreateOrUpdateCategoryForm";
import { CategoryResponseDto } from "../../shared/dtos/category/CategoryResponseDto";

interface UpdateCategoryModalProps {
  open: boolean;
  onClose: () => void;
  category: CategoryResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateCategoryModal: React.FC<UpdateCategoryModalProps> = ({
  open,
  onClose,
  category,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Category: ${category.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateCategoryForm
      isEditing={true}
      category={category}
      loading={loading}
      error={error}
    />
  </AppModal>
);
export default UpdateCategoryModal;
